import { AxiosInstance } from 'axios'

// In case we want to have a more complex set up logic later, it helps to have its own function for it
const userSetupHelper = async (api: AxiosInstance) => {
  await api.get(`/portal-users/setup`)
}

export default userSetupHelper
